import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const CompaniesRedux = createActions(
  {
    // Custom actions
    getCenterCompanyRequest: ['centerId'],
    getCenterCompanySuccess: ['results'],
    getCenterCompanyError: ['error'],
  },
  {
    prefix: 'COMPANIES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CompaniesRedux
export const CompaniesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
      // custom state
      center:{
        fetching:false,
        error:null,
        results:[]
      }
},
{
  get: true,
  // Default state
})
// ----------------------------ACTIVES-------------------------------
const getCenterCompanyRequest = state =>
  state.merge({ center: { fetching: true, error: null } }, d)

const getCenterCompanySuccess = (state, { results }) =>
  state.merge({ center: { fetching: false, error: null, results } }, d)

const getCenterCompanyError = (state, { error }) =>
  state.merge({ center: { fetching: false, error } }, d)
  
// --------------------------MAIN REDUCER ------------------------------------------
export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.getCenterCompanyRequest]: getCenterCompanyRequest,
    [Types.getCenterCompanySuccess]: getCenterCompanySuccess,
    [Types.getCenterCompanyError]: getCenterCompanyError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CompaniesRedux.js